import { FavoriteItem } from 'models/Favorites/FavoritesType';
import FAVORITES_QUERY from 'models/Favorites/FavoritesQuery';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import fetcher from 'utils/fetcher';
import useFavorites from './useFavorites';
import { CollectionItem } from 'models/Collection/CollectionType';

const useFavoriteCmsItems = (resourceType: string) => {
  const [favorites, setFavorites] = useState<FavoriteItem[]>([]);
  const [cmsIsLoading, setCmsIsLoading] = useState(true);
  const [
    cloudFavorites,
    fetchCloudFavorites,
    deleteFavorite,
    isLoading,
    setIsLoading,
  ] = useFavorites(resourceType);
  const contentAreaSlug =
    process.env.NEXT_PUBLIC_CONTENT_AREA_SLUG ?? 'mprnews';

  async function fetchCMSData(
    contentIds: string[],
    dispatch: Dispatch<SetStateAction<FavoriteItem[]>>
  ) {
    setCmsIsLoading(true);
    const data = await fetcher(FAVORITES_QUERY, {
      contentAreaSlug,
      contentIds,
    });
    let items;
    if (data?.contentList?.items.length == 0) return;
    if (resourceType == 'collection') {
      items = data.contentList.items
        .map((coll: CollectionItem) => coll.results.items)
        .flat()
        .sort((a: CollectionItem, b: CollectionItem) =>
          a.publishDate < b.publishDate ? -1 : 1
        )
        .toReversed();
    } else {
      items = data.contentList.items;
    }
    // dedupe
    const uniqueItems = items.filter(
      (item: FavoriteItem, idx: number, arr: FavoriteItem[]) => {
        return (
          arr.findIndex((i: FavoriteItem) => {
            return JSON.stringify(i) === JSON.stringify(item);
          }) === idx
        );
      }
    );
    dispatch(uniqueItems);
  }

  const ids = Array.from(cloudFavorites.keys());

  useEffect(() => {
    if (ids.length == 0 && !isLoading) {
      setFavorites([]);
      setCmsIsLoading(false);
    } else {
      fetchCMSData(ids, setFavorites);
    }
  }, [cloudFavorites, isLoading]);

  useEffect(() => {
    if (cmsIsLoading && favorites.length > 0 && ids.length > 0) {
      setCmsIsLoading(false);
    }
  }, [favorites, cmsIsLoading, ids]);

  return {
    favorites,
    deleteFavorite,
    isLoading: cmsIsLoading,
  };
};

export default useFavoriteCmsItems;
